import type { LegalCopy } from '../types'

export const gu: LegalCopy = {
  title: 'કાનૂની મદદ',
  subtitle: 'સામાન્ય કાનૂની મુશ્કેલીઓ, સરળ શબ્દોમાં. તમારી ભાષામાં સાંભળો, અને દરેક જવાબનો સરકારી સ્રોત જુઓ.',
  helplinesTitle: 'હેલ્પલાઇન (મફત કૉલ)',
  helplines: {
    emergency: 'ઇમરજન્સી: પોલીસ, ફાયર, એમ્બ્યુલન્સ',
    legal_aid: 'મફત કાનૂની મદદ (NALSA)',
    cyber: 'ઓનલાઇન / UPI છેતરપિંડી',
    women: 'મહિલા હેલ્પલાઇન',
    consumer: 'ગ્રાહક હેલ્પલાઇન'
  },
  faqTitle: 'સામાન્ય સવાલો',
  searchPlaceholder: 'શોધો: FIR, છેતરપિંડી, RTI, વકીલ…',
  noMatch: 'કોઈ સવાલ મળ્યો નહીં. નીચે તમારો સવાલ પૂછો.',
  sources: 'સરકારી સ્રોત',
  listen: 'સાંભળો',
  askTitle: 'તમારો કાનૂની સવાલ પૂછો',
  askHint: 'સમજો ફક્ત સરકારી વેબસાઇટો પરથી જ જવાબ આપે છે, સ્રોતની લિંક સાથે.',
  starters: ['શું મને મફત વકીલ મળી શકે?', 'કોઈએ મારી સાથે ઓનલાઇન છેતરપિંડી કરી. હું શું કરું?', 'પોલીસ મારી ફરિયાદ લખતી નથી. હું શું કરી શકું?'],
  disclaimer:
    'આ સરકારી સ્રોતોમાંથી લીધેલી સામાન્ય માહિતી છે, તમારા કેસ માટે કાનૂની સલાહ નથી. તમારા કેસ માટે વકીલ સાથે વાત કરો — કાનૂની સેવા સત્તામંડળ (15100) પાસેથી તમને મફત વકીલ મળી શકે છે.',
  topics: {
    get_free_aid: {
      q: 'મફત કાનૂની મદદ કેવી રીતે મળે?',
      a: 'NALSA ની મફત હેલ્પલાઇન 15100 પર કૉલ કરો. અથવા તમારી જિલ્લા કોર્ટમાં કાનૂની સેવા સત્તામંડળની ઓફિસે, અથવા તાલુકા કોર્ટમાં કાનૂની સેવા સમિતિ પાસે જાઓ. તમે ઓનલાઇન, ટપાલથી અથવા ઈ-મેલથી પણ અરજી કરી શકો છો. ફોર્મ મફત છે, અને વકીલની ફી અને કોર્ટનો ખર્ચ તમારા માટે ચૂકવવામાં આવે છે.'
    },
    who_free_aid: {
      q: 'મફત વકીલ કોને મળી શકે?',
      a: 'કાયદો (કાનૂની સેવા સત્તામંડળ અધિનિયમની કલમ 12) આ લોકોને મફત કાનૂની મદદ આપે છે: મહિલાઓ અને બાળકો, SC/ST ના લોકો, દિવ્યાંગ વ્યક્તિઓ, ઔદ્યોગિક કામદારો, માનવ તસ્કરી કે વેઠ (બળજબરીથી મજૂરી) ના ભોગ બનેલા લોકો, આપત્તિ, જાતિગત અત્યાચાર કે વંશીય હિંસાના ભોગ બનેલા લોકો, કસ્ટડીમાં રહેલા લોકો, અને જેમની વાર્ષિક આવક તેમના રાજ્યે નક્કી કરેલી મર્યાદાથી ઓછી છે એવા લોકો. આવકની મર્યાદા દરેક રાજ્યમાં અલગ છે.'
    },
    fir: {
      q: 'પોલીસ મારી FIR નોંધતી નથી. હું શું કરું?',
      a: 'ગંભીર (કોગ્નિઝેબલ) ગુનાની ફરિયાદ તમે કોઈપણ પોલીસ સ્ટેશનમાં કરી શકો છો, ભલે ગુનો બીજે ક્યાંક થયો હોય — આને ઝીરો FIR કહેવાય છે. પોલીસે તમને FIR ની નકલ મફત આપવી જ પડે. જો પોલીસ ના પાડે, તો તમારી ફરિયાદ લખીને ટપાલથી પોલીસ અધિક્ષક (SP) ને મોકલો. જો SP પણ કંઈ ન કરે, તો તમે સોગંદનામા સાથે મેજિસ્ટ્રેટ પાસે અરજી કરી શકો છો.'
    },
    cyber_fraud: {
      q: 'ઓનલાઇન કે UPI છેતરપિંડીમાં મારા પૈસા ગયા. હું શું કરું?',
      a: 'તરત જ 1930 પર કૉલ કરો — આ રાષ્ટ્રીય સાયબર ક્રાઇમ હેલ્પલાઇન છે, મફત છે અને દિવસ-રાત ચાલુ રહે છે. જલદી જાણ કરવાથી પૈસા આગળ મોકલાતા અટકાવવામાં મદદ મળે છે. સાથે જ cybercrime.gov.in પર “Financial Fraud” માં ફરિયાદ નોંધાવો.'
    },
    women: {
      q: 'કોઈ મહિલા હિંસા કે હેરાનગતિનો સામનો કરી રહી છે. તેને મદદ ક્યાંથી મળે?',
      a: 'ઇમરજન્સીમાં પોલીસ, ફાયર કે એમ્બ્યુલન્સ માટે 112 ડાયલ કરો. મફત મહિલા હેલ્પલાઇન 181 પર દિવસ-રાત ક્યારેય પણ કૉલ કરો. તમે તમારું નામ છુપાવી શકો છો, અને આ હેલ્પલાઇન તમને પોલીસ, વન સ્ટોપ સેન્ટર, હોસ્પિટલ કે કાનૂની મદદ સાથે જોડે છે. રાષ્ટ્રીય મહિલા આયોગની હેલ્પલાઇન 14490 પણ છે, અને આયોગ ઓનલાઇન ફરિયાદ પણ લે છે.'
    },
    consumer: {
      q: 'દુકાન કે કંપનીએ મને છેતર્યો. ફરિયાદ ક્યાં કરું?',
      a: 'રાષ્ટ્રીય ગ્રાહક હેલ્પલાઇન 1915 પર કૉલ કરો (મફત, સવારે 8 થી રાત્રે 8), 8800001915 પર WhatsApp મેસેજ મોકલો, અથવા consumerhelpline.gov.in પર ફરિયાદ કરો. ગ્રાહક આયોગમાં કેસ કરવો હોય, તો e-Daakhil પર ઓનલાઇન કરી શકો છો.'
    },
    summons: {
      q: 'મને કોર્ટનું સમન્સ મળ્યું છે. હું શું કરું?',
      a: 'સમન્સમાં લખેલું હોય છે કે તમારે કઈ તારીખે કોર્ટમાં આવવાનું છે. જો તમે પાત્ર હો, તો કેસના કોઈપણ તબક્કે મફત વકીલ મળી શકે છે: 15100 પર કૉલ કરો અથવા તમારી જિલ્લા કોર્ટમાં કાનૂની સેવાની ઓફિસે જાઓ. તમારો કેસ અને તેની આગલી તારીખ eCourts વેબસાઇટ કે એપ પર જોઈ શકો છો.'
    },
    case_status: {
      q: 'મારા કોર્ટ કેસનું સ્ટેટસ કેવી રીતે જોઉં?',
      a: 'services.ecourts.gov.in પર જાઓ, અથવા eCourts Services એપ વાપરો, અને તમારા 16-અંકના CNR નંબર કે કેસની બીજી માહિતીથી શોધો. SMS પણ કરી શકો છો: ECOURTS, પછી એક સ્પેસ, પછી તમારો CNR નંબર લખીને 9766899899 પર મોકલો.'
    },
    lok_adalat: {
      q: 'લોક અદાલત એટલે શું?',
      a: 'લોક અદાલત બંને પક્ષોની સંમતિથી કેસનો નિકાલ કરે છે. તેમાં કોઈ કોર્ટ ફી લાગતી નથી, અને જો કોર્ટમાં ચાલતો કેસ અહીં પતી જાય, તો ભરેલી કોર્ટ ફી પાછી મળે છે. તેનો નિર્ણય કોર્ટના હુકમનામા (ડિક્રી) જેવો અંતિમ અને બંધનકર્તા છે, અને તેની સામે અપીલ થઈ શકતી નથી.'
    },
    rti: {
      q: 'RTI અરજી કેવી રીતે કરું?',
      a: 'કેન્દ્ર સરકારની ઓફિસો માટે rtionline.gov.in પર ઓનલાઇન અરજી કરો. ફી ₹10 છે; જો તમે ગરીબી રેખા નીચે (BPL) હો, તો કોઈ ફી નથી (તમારું BPL પ્રમાણપત્ર જોડો). અધિકારીએ 30 દિવસમાં જવાબ આપવો પડે, અને જો કોઈના જીવન કે સ્વતંત્રતાની વાત હોય તો 48 કલાકમાં. 30 દિવસમાં જવાબ ન મળે, તો પછીના 30 દિવસમાં મફત પહેલી અપીલ કરી શકો છો.'
    },
    grievance: {
      q: 'સરકારી ઓફિસ મારું કામ કરતી નથી. ફરિયાદ ક્યાં કરું?',
      a: 'pgportal.gov.in પર CPGRAMS માં ફરિયાદ નોંધાવો — તે દિવસ-રાત ખુલ્લું છે (તેની એપ પણ છે, અને UMANG પર પણ છે). 21 દિવસમાં ઉકેલવાનું લક્ષ્ય છે. તેમાં RTI ની બાબતો, કોર્ટ કેસ, ધાર્મિક બાબતો કે સરકારી કર્મચારીઓની નોકરી સંબંધી બાબતો લેવામાં આવતી નથી.'
    }
  }
}
